<template>
    <q-radio
            :model-value="stringValue"
            :val="val"
            v-bind="$attrs"
            @click="open"
    >
        {{ label }}
        <div v-show="humanValue">
            <strong>{{ humanValue }}</strong>
        </div>
    </q-radio>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DateRangePickerMixin from './DateRangePickerMixin';

export default defineComponent({
  mixins: [DateRangePickerMixin],
  props: {
    val: {
      type: String,
      required: true,
    },
    label: String,
  },
  computed: {
    stringValue(): string|null {
      if (this.modelValue && this.modelValue.start && this.modelValue.end) {
        return this.val;
      }
      return null;
    },
  },
});
</script>
